import React, { useState } from 'react';
import { Card } from '../Card/Card';
import { Form } from './Form';
import { TextField } from './TextField/TextField';
import { Select } from './Select/Select';
import { SearchSelect } from './Select/SearchSelect';
import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import { RadioGroup } from './Radio/RadioGroup';
import { Datepicker } from './Datepicker/Datepicker';
import { Checkbox } from './Checkbox/Checkbox';
import { FileUploadExample } from './FileUpload/FileUploadExample';
import { TextArea } from './TextArea/TextArea';
import { AsyncSearch } from './AsyncSearch/AsyncSearch';
import { TagsInput } from './TagsInput/TagsInput';
import { Label } from './Label/Label';
import { ScrollWrapper } from '../ScrollWrapper/ScrollWrapper';
import { PercentageField } from './TextField/PercentageField';
import { Stack } from '../Stack/Stack';

const LOREM =
  'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, labore sequi vitae optio similique sapiente! Sint totam magni consequatur nemo provident excepturi fugit quis commodi distinctio! Iste dolorum quis consequuntur?';

export function FormExample(): JSX.Element {
  const [displayDescription, setDisplayDescription] = useState(false);
  const [formModel, setFormModel] = useState({
    select: '1',
    check: false,
    multiselect: ['2', '3'],
    searchselect: '1',
    radio: 'a',
    async: '',
    asyncMulti: [],
    tags: ['test'],
    json: '{"token:"dd6438cd-46a5-489a-bbe7-004b6f064d37","language":"en","user_id":"645a5dc1-34af-4a9d-ae6e-d6cfc571d9b6","valid_until":"2019-07-09T13:49:52+02:00","memberships":[{"id":"0a80c559-f327-4ad1-ad0b-ae5d17802259","role":"admin","comment":null,"_permissions":["update","destroy"],"company":{"id":"33748bcc-eb17-4888-8480-b6e794deebfd","name":"Krasser Stoff Merchandising GmbH","slug":"krasserstoff","vat_id":null,"vat_number":null,"features":["ticketing","merch"],"address":{"city":"Berlin","address":"Falckensteinstr. 48","post_code":"10997","country_code":"de"},"bank_account":{},"_permissions":["show","update","destroy"],"icon":{"id":"5c376d3b-0c2f-4587-b0f4-72c631755cac","url":"https://staging.krasserstoff.com/api/v2/assets/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","tags":[],"order":0,"thumbs":{"75":"https://staging.krasserstoff.com/api/v2/assets/75/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","100":"https://staging.krasserstoff.com/api/v2/assets/100/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","150":"https://staging.krasserstoff.com/api/v2/assets/150/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","180":"https://staging.krasserstoff.com/api/v2/assets/180/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","240":"https://staging.krasserstoff.com/api/v2/assets/240/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","360":"https://staging.krasserstoff.com/api/v2/assets/360/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","370":"https://staging.krasserstoff.com/api/v2/assets/370/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","500":"https://staging.krasserstoff.com/api/v2/assets/500/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","740":"https://staging.krasserstoff.com/api/v2/assets/740/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","1000":"https://staging.krasserstoff.com/api/v2/assets/1000/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg","1500":"https://staging.krasserstoff.com/api/v2/assets/1500/5c376d3b-0c2f-4587-b0f4-72c631755cac.jpeg"}}}}]}',
  });

  return (
    <Form
      className="styleguide__form"
      model={formModel}
      onSubmit={(m) => {
        // eslint-disable-next-line
        console.log(m);
      }}
      onInput={(m) => setFormModel(m)}
    >
      <Card
        style={{ height: '800px' }}
        title="A Form"
        scrollShadows
        footer={
          <>
            <Button
              title="Toggle descriptions"
              onClick={() => {
                setDisplayDescription(!displayDescription);
              }}
            />
            <Button title="SUBMIT FORM" type="primary" isSubmit />
          </>
        }
      >
        <ScrollWrapper>
          <Stack>
            <Label title="Textfield" />
            <TextField
              name="textfield"
              label="This is a textfield"
              description={displayDescription ? LOREM : ''}
              icon="link"
              actions={<Icon name="lock" />}
              loading
            />
            <Label title="PercentageField" />
            <PercentageField
              name="percentageField"
              label="This is a percentageField"
              description={displayDescription ? LOREM : ''}
              icon="link"
              actions={<Icon name="lock" />}
            />
            <Label title="Textarea" />
            <TextArea icon="link" name="area" label="MultiLine" actions={<Icon name="lock" />} />
            <TextArea name="json" json label="JSONinput" />

            <Label title="Checkbox" />
            <Checkbox name="check" label="Test checkbox" />

            <Label title="Fileupload" />
            <FileUploadExample description={displayDescription ? LOREM : ''} />

            <Label title="Select Simple" />
            <Select
              name="select"
              label="This is a select"
              allowEmpty
              options={[
                { value: '1', label: 'Option 1' },
                { value: '2', label: 'Option 2' },
              ]}
              description={displayDescription ? LOREM : ''}
              icon="activity"
              actions={<Icon name="at-sign--sm"></Icon>}
            />

            <Label title="Search select" />
            <SearchSelect
              name="searchselect"
              values={[
                { id: '1', label: 'select1' },
                { id: '2', label: 'option2' },
                { id: '3', label: 'choice3' },
                { id: '4', label: 'select4' },
                { id: '5', label: 'select5' },
              ]}
              label="SearchSelect"
              description="Search for 1 item"
            />

            <Label title="Searchselect multiple" />
            <SearchSelect
              icon="at-sign"
              name="multiselect"
              values={[
                {
                  id: '1',
                  label: 'this is a div1',
                  content: <div>This is a div1</div>,
                },
                { id: '2', label: 'option2' },
                {
                  id: '3',
                  label: 'this is a div 3',
                  content: <div>This is a div3</div>,
                },
                { id: '4', label: 'select4' },
                { id: '5', label: 'select5' },
              ]}
              notFound={
                <div>
                  <Button
                    title="NO LUCK? ADD NEW LOGO TO DATABASE"
                    type="link"
                    onClick={() => {
                      alert('this is an add modal');
                    }}
                  />
                </div>
              }
              label="Multiselect"
              description="Select Multiple items"
              actions={<Icon name="calendar--sm" />}
            />

            <Label title="Radio" />
            <RadioGroup
              name="radio"
              values={[
                { label: 'choice A', value: 'a' },
                { label: 'choice B', value: 'b' },
              ]}
            />

            <Label title="Datepicker" />
            <Datepicker name="date" label="Date" description={displayDescription ? LOREM : ''} />

            <Label title="Datepicker with time select" />
            <Datepicker
              name="hourpicker"
              label="Date with hourpicker"
              hourpicker
              description={displayDescription ? LOREM : ''}
            />

            <Label title="Async Search" />
            <AsyncSearch
              label="Async Search"
              name="async"
              searchIn={['company', 'shop', 'category', 'event']}
              maxResults={20}
              icon="at-sign--sm"
              description={displayDescription ? LOREM : ''}
              onSelect={(m) => {
                // eslint-disable-next-line
                console.log(m);
              }}
            />
            <Label title="Async Search Multiselect" />
            <AsyncSearch
              label="Async Search - Multiselect"
              name="asyncMulti"
              searchIn={['category', 'venue', 'event', 'product']}
              maxResults={20}
              description={displayDescription ? LOREM : ''}
              onSelect={(m) => {
                // eslint-disable-next-line
                console.log(m);
              }}
            />

            <Label title="Tags Input" />
            <TagsInput icon="search" label="Tags Input" name="tags" description={displayDescription ? LOREM : ''} />
          </Stack>
        </ScrollWrapper>
      </Card>
    </Form>
  );
}
